const DASHBOARD_STATUS = {
  IDLE: 'IDLE',
  ACTIVE: 'ACTIVE',
  UNLOADED: 'UNLOADED',
};

export default DASHBOARD_STATUS;
